import {Component, OnDestroy} from '@angular/core';
import {ObjectList} from '../../model/object-list';
import {PaymentHistoriesResource} from '../../model/model-resource';
import {Router} from '@angular/router';
import {PaymentHistory} from '../../model/payment-history';

@Component({
  selector: 'app-payment-histories-list-page',
  templateUrl: './payment-histories-list-page.component.html',
  styleUrls: ['./payment-histories-list-page.component.scss']
})
export class PaymentHistoriesListPageComponent implements OnDestroy {

  list: ObjectList<PaymentHistory>;

  columns = [
    'changed',
    'invoiceId',
    'payment',
    'sum',
    'description',
    'created'
  ];

  constructor(private resource: PaymentHistoriesResource,
              private router: Router
              ) {
    this.list = new ObjectList<PaymentHistory>('paymentHistories', this.resource);
  }

  ngOnDestroy() {
    this.list.disconnect();
    this.list = null;
  }

  navigateTo(commands): void {
    this.router.navigate(commands);
  }

}
